<template>
  <div class="usc-datacard gutter-lg mb body">
    <slot name="title"></slot>

    <div class="usc-datacard__cards">
      <div class="usc-datacard__card" v-for="(item, index) in data">
        <div class="usc-datacard__col usc-datacard__col--left">
          <div class="usc-datacard__number">
            {{item.number}}
          </div>
          <div class="usc-datacard__subtext">
            {{item.subtext}}
          </div>
        </div>
        <div class="usc-datacard__col">
          <img :src="item.img" alt="">
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'DataVizCard',
  props: ['data'],
  data () {
    return {

    }
  },
  computed: {
    hasSVG () {
      return this.$slots.svg
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '~styles/vars';
  .usc-datacard {
    h3 {
      margin-bottom: 30px;
      max-width: 250px;
    }
    &__cards {
      display: flex;
      flex-flow: row wrap;
      justify-content: space-around;
    }
    &__card {
      display: flex;
      flex-flow: row nowrap;
      -webkit-box-shadow: 0px 3px 12px 6px rgba(0,0,0,0.05);
      -moz-box-shadow: 0px 3px 12px 6px rgba(0,0,0,0.05);
      box-shadow: 0px 3px 12px 6px rgba(0,0,0,0.05);
      width: 100%;
      max-width: 465px;
      min-width: 300px;
      height: 141px;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;
      // margin-right: 20px;
      @media(min-width: $screen-sm-min) {
        width: 48%;
        flex-shrink: 0;

      }
    }
    &__col {
      text-align: center;
      width: 50%;
      height: 100%;
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-content: center;
      &--left {
        border-right: 1px solid rgba(50, 50, 51, 0.07);
      }
    }
    &__number {
      font-family : $fNational;
      font-weight : $fBold;
      font-size : 40px;
      line-height : 24px;
      letter-spacing : 1.2px;
      text-transform : uppercase;
      color: $cMaroon;
      margin-bottom: 15px;
    }
    &__subtext {
      font-family : $fNational;
      font-style : italic;
      font-size : 15px;
      line-height : 18px;
      color : #707070;
      padding-right: 10px;
      padding-left: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/DataVizCards.vue